import "../styles/Login.scss";
import React, { useEffect, useState } from "react";
import { auth } from "@/utils/firebase";
import {
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { getUser } from "@/hooks/useLocalStorage";

import Logo from "../assets/logo.svg";
import Spinner from "@/components/Spinner";
import { Input } from "@Components/input";
import { Label } from "@/components/ui/label";
import { Button } from "@Components/button";
import { useNavigate } from "react-router-dom";
import ResetAlert from "@/components/ResetAlert";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const signIn = async (e) => {
    e.preventDefault();
    if (!email || !password) return;

    try {
      setLoading(true);
      await signInWithEmailAndPassword(auth, email.trim(), password);
    } catch (error) {
      // Handling error codes
      if (error.code === "auth/invalid-credential") {
        setError("Incorrect login email and password.");
      } else {
        setError("An error occurred during login.");
      }
      console.error("Error code:", error.code, "Error message:", error.message);
      setLoading(false);
    }
  };

  const resetPassword = () => {
    if (!email) {
      alert("Please enter your email to reset password!");
      return;
    }

    // Regular expression for validating email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address!");
      return;
    }

    sendPasswordResetEmail(auth, email)
      .then(() => {
        setShowAlert(true);
        console.log("Reset email sent");
      })
      .catch((err) => {
        console.log("Error sending reset email:", err.code, err.message);
      });
  };

  useEffect(() => {
    const user = getUser();
    if (user) {
      navigate("/home");
    }
  });

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="loginWrapper">
      <div className="loginLeft">
        <form onSubmit={signIn} className="w-[70%] mobileLoginWrapper">
          <img src={Logo} alt="iSettle" className="logo" />

          <p className="mt-5 mb-4 text-sm text-muted">
            Enter your email and password to continue
          </p>

          <div className="grid w-full max-w-sm items-center gap-1.5">
            <Label htmlFor="email" className="text-muted">
              Email
            </Label>

            <Input
              type="text"
              value={email}
              placeholder="Enter email"
              className="w-full h-[50px] mb-3"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="grid w-full max-w-sm items-center gap-1.5">
            <Label htmlFor="email" className="text-muted">
              Password
            </Label>

            <Input
              type="password"
              value={password}
              placeholder="Enter password"
              className="w-full h-[50px] mb-3"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && <p className="my-2 text-sm text-red-500">{error}</p>}

          <p
            onClick={resetPassword}
            className="my-2 text-sm text-green cursor-pointer"
          >
            Forgot password?
          </p>

          <Button
            type="submit"
            variant="outline"
            disabled={!email || !password}
            className="w-full max-w-sm h-[50px] text-white mt-1.5 bg-green"
          >
            Login
          </Button>

          <p className="mt-4 text-sm">
            Don't have an account?{" "}
            <span
              onClick={() => navigate("/signup")}
              className="text-green cursor-pointer"
            >
              Sign up
            </span>
          </p>
        </form>
      </div>

      {/* Alert */}
      <ResetAlert
        email={email}
        showAlert={showAlert}
        setShowAlert={setShowAlert}
      />

      <div className="loginRight">
        <div className="contentBox">
          <h3 className="text-white text-3xl font-bold">
            Your Premier Destination for Scrap Plastic Trading
          </h3>
          <p className="mt-2 text-white text-lg">
            Where plastic trading meets simplicity. Join us in shaping a
            sustainable future.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
